import CategoryTree from './src/main';

/* istanbul ignore next */
CategoryTree.install = function(Vue) {
  Vue.component(CategoryTree.name, CategoryTree);
};

export default CategoryTree;
